var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ADBABD",
    strokeMiterlimit: 10,
    strokeWidth: 65
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 82.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 512,
    r: 82.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 895.5,
    cy: 512,
    r: 82.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionGray);
export default ForwardRef;